import React, { useState, useRef } from "react";
import "../../index.css";
import Card from "./CardCooper";
import Road from "./Road";
import Description from "./Description";

const Cooperation = ({ data }) => {
  const blocks = 7;
  const roadRef = useRef(null);
  const [carPosition, setCarPosition] = useState(0);

  const handleMouseMove = (e) => {
    if (roadRef.current) {
      const roadRect = roadRef.current.getBoundingClientRect();
      const mouseY = e.clientY - roadRect.top;
      const roadHeight = roadRect.height;

      let blockIndex = Math.floor((mouseY / roadHeight) * blocks);

      if (blockIndex < 0) blockIndex = 0;
      if (blockIndex >= blocks) blockIndex = blocks - 1;

      setCarPosition(blockIndex);
    }
  };

  return (
    <div
      className="min-h-screen w-full xs:p-5 p-2.5 flex flex-col leading-tight font-manrope font-medium"
      onMouseMove={handleMouseMove} // Двигаем машинку по всей ширине экрана
    >
      <div className="h-fit w-full text-left xs:mb-8 mb-4 ">
        <h1 className="text-[28px] xs:text-[36px] lg:text-[40px]">{data.title}</h1>
      </div>

      <div className="grid lg:grid-cols-[52px_29%_45%] xs:grid-cols-[52px_35%_50%] grid-cols-[52px_83%] auto-rows-fr lg:justify-evenly justify-between w-full h-full">
        <div ref={roadRef} className="relative h-full w-full">
          <Road
            roadImage={data.road.roadSegment}
            carImage={data.road.carImage}
            carPosition={carPosition}
          />
        </div>
        <div className="h-full flex flex-col justify-around">
          {data.card_list.map((card, index) => (
            <Card
              key={index}
              title={card.title}
              image={card.image}
              bg_color={card.bg_color}
              title_color={card.title_color}
              isVisible={index === carPosition}
              hover_color={card.hover_color}
              index={card.index}
              index_color={card.index_color}
              description_top_xs={card.description_top_xs}
              description_top_mobile={card.description_top_mobile}
              description_bot_xs={card.description_bot_xs}
              description_bot_mobile={card.description_bot_mobile}
              description_top_color={card.description_top_color}
              description_bot_color={card.description_bot_color}
            />
          ))}
        </div>
        <div className="hidden xs:block">
          <div className="h-full flex flex-col justify-around">
          {data.card_list.map((card, index) => (
            <Description
              description_top_lg={card.description_top_lg}
              description_bot_lg={card.description_bot_lg}
              description_top_xs={card.description_top_xs}
              description_bot_xs={card.description_bot_xs}
              description_top_color={card.description_top_color}
              description_bot_color={card.description_bot_color}
              bar_color={card.bar_color}
            />
          ))}
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Cooperation;
